import React from 'react'
import useDeliveryOptions from '@hooks/useDeliveryOptions'
import {CheckoutContext} from '@page-components/Checkout/Checkout/CheckoutContext'

import useInitialData from './useInitialData'

export default function DeliveryContextProvider({children}: {children: React.ReactNode}) {
  const initialData = useInitialData()

  const {timeOptions, setTimeOptions, deliveryType, setDeliveryType} = useDeliveryOptions(
    initialData?.website
  )

  return (
    <CheckoutContext.Provider value={{timeOptions, setTimeOptions, deliveryType, setDeliveryType}}>
      {children}
    </CheckoutContext.Provider>
  )
}
